import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import BackpackEventConfig, { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { FoodMaterialEntity } from "./config/FoodMaterialConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class swingPlateShopItem extends cc.Component {

    @property({type:cc.Node,displayName:"videoLayout"})
    videoLayout:cc.Node = null;

    @property({type:cc.Label,displayName:"数量文本"})
    lbCount:cc.Label = null;

    @property({type:cc.Sprite,displayName:"食物显示图片"})
    spr:cc.Sprite = null;

    foodMaterialEntity:FoodMaterialEntity = null;

    bindData(foodMaterialEntity:FoodMaterialEntity){
        this.foodMaterialEntity = foodMaterialEntity;
    }

    onBtnMe(){
        // 选择此节点 需要发送事件 并且删除一个物品并刷新界面
        O1HD.emit("SwingPlateManager.addFoodMaterial" , this.foodMaterialEntity.uniqueId , ( flag : boolean )=>{
            if ( flag ){
                NormalGameManager._instance.onOutGoods( this.foodMaterialEntity.goodsId );
                this.updateItem().then();
            }
        } );
    }

    onBtnVideo(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            if( this.foodMaterialEntity.goodsId ){
                NormalGameManager._instance.onPushGoods( this.foodMaterialEntity.goodsId,10 );
                NormalGameManager._instance.writeGameData();
                this.updateItem();
            }
        },()=>{},null,"看视频添加食品");
    }

    async updateItem(){
        if(!this.foodMaterialEntity){
            //没有数据
            return;
        }
        if(this.foodMaterialEntity.type == 2){
            this.node.active = false;
        }
        let goodsId = this.foodMaterialEntity.goodsId;
        if(goodsId!=null){
            // 加载图片
            let saveData = NormalGameManager._instance.getGameData().backpack[goodsId];
            if(saveData){
                let count = saveData.num;
                this.lbCount.string = `×${data_control.getNumberFormat(count)}`;
                this.videoLayout.active = false;
            }else{
                this.lbCount.string = "";
                if(this.foodMaterialEntity.videoFlag){
                    this.videoLayout.active = true;
                }else{
                    this.node.active = false;
                }
            }
            let backConfig = backPackEventMap()[goodsId];
            let spPath = backConfig.spPath;
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.backPackGameBundle);
            bundle.load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
                if(err){
                    console.debug("加载物品图片失败 #swingPlateShopItem",err);
                    return;
                }
                this.spr.spriteFrame = assets;
            });
        }else{
            this.node.active = false;
        }
    }

}
